import { getUrlSync, IActionContext } from '@msdyn365-commerce/core';
import { SalesOrder, SalesStatus } from '@msdyn365-commerce/retail-proxy';
import { StringExtensions } from '@msdyn365-commerce-modules/retail-actions';

/**
 * Helpers copied from the order-management package's
 * modules/order-history-with-search-and-filters/common/get-sales-order module.
 *
 * They are not exported from the package root, and the package ships no type declarations for deep
 * imports, so they are reproduced here to keep the order history component overrides type safe.
 * Keep these in sync with the package when it is upgraded.
 */

/**
 * Resources for order status.
 */
export interface IMilOrderHistoryOrderStatusResources {
    orderStatusCreated: string;
    orderStatusDelivered: string;
    orderStatusInvoiced: string;
    orderStatusCanceled: string;
}

/**
 * Retrieves the url for order details page.
 * @param actionContext - Core action context.
 * @param salesOrder - Order information.
 * @returns Url to order details.
 */
export const GetMilOrderDetailsPageUrl = (actionContext: IActionContext, salesOrder: SalesOrder): string => {
    const orderDetailsUrl = getUrlSync('orderDetails', actionContext) || '';
    const separator = orderDetailsUrl.includes('?') ? '&' : '?';
    if (!StringExtensions.isNullOrWhitespace(salesOrder.SalesId)) {
        // Redirect with sales order sales id
        return `${orderDetailsUrl}${separator}salesId=${salesOrder.SalesId}`;
    }

    // Redirect with sales order transaction id
    return `${orderDetailsUrl}${separator}transactionId=${salesOrder.Id}`;
};

/**
 * Retrieves the text for order status.
 * @param status - The sales order status.
 * @param resources - Resources where we can find the text.
 * @returns The text for the order status.
 */
export const GetMilOrderStatusLabel = (status: SalesStatus | undefined, resources: IMilOrderHistoryOrderStatusResources): string => {
    switch (status) {
        case SalesStatus.Created:
            return resources.orderStatusCreated;
        case SalesStatus.Delivered:
            return resources.orderStatusDelivered;
        case SalesStatus.Invoiced:
            return resources.orderStatusInvoiced;
        case SalesStatus.Canceled:
            return resources.orderStatusCanceled;
        default:
            return '';
    }
};
